<script setup>
import { defineProps, defineEmits, onMounted, ref } from 'vue';
import { HUB } from '@/hub'
import { Gems } from "@/gems";
import defaultImg from "../images/default.png";
import store from '../store';

const props = defineProps(['userId'])
const emits = defineEmits(['control-user-modal', 'update-user-data']);
const userData = ref({});
const internal = ref("");
const professionalName = ref("");
const fullName = ref("");
const genderId = ref('null');
const categoryId = ref('null');
const jobId = ref('null');
const email = ref("");
const username = ref("");
// const costHour = ref("");
// const hourValue = ref("");
// const dailyHours = ref("");
const isAdmin = store.getters.User.admin;
const manageUserHours = ref(false)
const newWorkingHours = ref({
    date: new Date().toISOString().split('T')[0],
    hours: 1
})
let hasTeams = ref(false);
let hasIntime = ref(false);
let hasHeadship = ref(false);

function HideModal() {
    emits('control-user-modal')
}

onMounted(async () => {

    hasIntime.value = store.getters.User.apps?.intime?.active == 1;

    await GetData()

    Gems.Tooltip(document.getElementById('icon-close-modal'), 'Fechar', 'tooltip');

    if (isAdmin)
        Gems.Tooltip(document.getElementById('image-user'), 'Mudar a foto', 'tooltip');

    const divLeftHeight = document.getElementById('div-left').offsetHeight;
    const divRightHeight = document.getElementById('div-right');

    if (divLeftHeight > divRightHeight.offsetHeight)
        divRightHeight.style.height = `${divLeftHeight}px`
})

async function UpdateUserInfo() {
    let fileImage = document.getElementById('input-img-user').files;

    if (fileImage[0] && !CheckFile(fileImage[0]))
        return

    const formData = new FormData();
    if (fileImage[0]) {
        formData.append("image", fileImage[0]);
    }

    if (!HUB.RequiredFieldsValid())
        return

    if (!IsValidEmail(email.value)) {
        Gems.Telegram("Email inválido", 'tele-not-allowed');
        return
    }

    formData.append('input', JSON.stringify({
        user_id: props.userId
        , internal: internal.value
        , name: professionalName.value
        , full_name: fullName.value
        , gender_id: genderId.value
        , category_id: categoryId.value
        , job_id: jobId.value
        , username: username.value
        , email: email.value
        // , cost_hour: costHour.value
        // , hour_value: hourValue.value
        // , daily_hours: dailyHours.value
        , has_intime: hasIntime.value
        , old_job: userData.value.user?.job_id ?? null
    }))

    const response = await HUB.CallBackEnd({
        action: HUB.Action("update-user-info"),
        data: formData
    })

    if (!response.error) {
        Gems.CallWS({ app: "kpi", action: "update-users-data" });
        Gems.Telegram("Dados atualizados", 'tele-success')

        if (props.userId == store.getters.User.id && fileImage[0])
            store.getters.User.photo = URL.createObjectURL(fileImage[0])

        emits('control-user-modal', {
            modalInfo: false
        });

        emits('update-user-data', {
            internal: internal.value
            , name: professionalName.value
            , full_name: fullName.value
        });
    }
    Gems.CallWS({ app: "kpi", action: "update-users-data" });
}

function UpdateImage() {

    if (!isAdmin && userData.value.user.can_upload_photo != 1)
        return

    const inputImage = document.getElementById('input-img-user')

    inputImage.click();
}

async function SelectFile(e) {
    userData.value.user.src = URL.createObjectURL(e.target.files[0])

    if (!isAdmin && userData.value.user.can_upload_photo == 1)
        UpdateUserInfo()
}


function CheckFile(file) {
    if (file?.size > 10485760) {
        Gems.Telegram("Tamanho máximo permitido: 10MB");
        return false;
    }

    if (!IsAllowedExtension(file?.name)) {
        document.getElementById("input-img-user").value = "";
        Gems.Telegram("Carregue um ficheiro válido (.jpg, .jpeg ou .png)", 'tele-not-allowed');
        return false;
    }

    return true;
}

function IsAllowedExtension(fileName) {
    const extension = fileName?.split('.').pop()?.toLowerCase()

    return ['jpg', 'jpeg', 'png'].includes(extension)
}

async function GetData() {
    const response = await HUB.CallBackEnd({
        action: HUB.Action("get-profile-dependencies"),
        data: { user_id: props.userId, has_intime: hasIntime.value }
    });

    if (props.userId) {
        genderId.value = response.data.user.gender_id
        categoryId.value = response.data.user.category_id
        jobId.value = response.data.user.job_id
        internal.value = response.data.user.internal
        professionalName.value = response.data.user.professional_name
        fullName.value = response.data.user.full_name
        username.value = response.data.user.username
        email.value = response.data.user.email
        // costHour.value = response.data.user.cost_hour
        // hourValue.value = response.data.user.hour_value
        // dailyHours.value = response.data.user.daily_hours
    }

    userData.value = response.data;

    if (Object.keys(userData.value.teams).length > 0)
        hasTeams.value = true;

    if (Object.keys(userData.value.hierarchy).length > 0)
        hasHeadship.value = true;
}

function normalizeWorkingHoursHours() {
    const hours = Number(newWorkingHours.value.hours)

    if (Number.isNaN(hours)) {
        newWorkingHours.value.hours = 1
        return
    }

    newWorkingHours.value.hours = Math.max(1, Math.min(24, Math.floor(hours)))
}

async function AddWorkingHour() {
    if (!newWorkingHours.value.date) {
        Gems.Telegram('Selecione uma data válida', 'tele-not-allowed')
        return
    }

    normalizeWorkingHoursHours()

    if (newWorkingHours.value.hours < 1 || newWorkingHours.value.hours > 24) {
        Gems.Telegram('Horas deve ser entre 1 e 24', 'tele-not-allowed')
        return
    }

    const response = await HUB.CallBackEnd({
        action: HUB.Action("set-working-hours"),
        data: { newWorkingHours: newWorkingHours.value, actual_daily_hours: userData.value.actual_daily_hours, requested_user_id: props.userId }
    })

    if(response.error)
        Gems.Telegram('Ocorreu um erro', 'tele-not-allowed')

    newWorkingHours.value = {
        date: new Date().toISOString().split('T')[0],
        hours: 1
    }

    GetData()
}

async function RemoveWorkingHour(elem) {
    const response = await HUB.CallBackEnd({
        action: HUB.Action("remove-working-hours"),
        data: { workingHour: elem }
    })

    if(response.error)
        Gems.Telegram('Ocorreu um erro', 'tele-not-allowed')

    GetData()    
}

function IsValidEmail(emailValue) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(emailValue ?? '').trim())
}

</script>

<template>
    <div class="div-modal">
        <div class="div-modal-content">
            <div class="div-container">

                <div class="div-user-content">
                    <div class="div-close-modal">
                        <i id="icon-close-modal" class="fas fa-times clickable" @click="HideModal()"></i>
                    </div>

                    <div class="div-user-image-container">
                        <div class="div-user-image-content">
                            <div class="div-user-image inputs-border" :class="{ 'hover-inputs-border': isAdmin }">
                                <img id="image-user" :src="userData?.user?.src ?? defaultImg" alt="user-image"
                                    :class="{ 'default-cursor': !isAdmin && userData?.user?.can_upload_photo != 1 }"
                                    @click="UpdateImage()" @error="$event.target.src = defaultImg">
                                <input id="input-img-user" type="file" class="hidden" accept=".jpg,.jpeg,.png,image/jpeg,image/png" @change="SelectFile($event)">
                            </div>
                        </div>
                    </div>
                </div>

                <div v-show="manageUserHours">
                    <div class="div-left-container div-manage-user-hours scrollbar">
                        <div class="div-row div-add-working-hour">
                            <label>HORAS CONTRATADAS</label>
                            <label v-if="isAdmin">REGISTAR HORAS CONTRATADAS</label>
                        </div>

                        <div class="div-row div-add-working-hour">
                            <div class="div-daily-hours-content">
                                <div v-for="(dailyHour, index) in userData.daily_hours" :key="index">
                                    <div class="div-date-working-hour">
                                        <span>{{ dailyHour.begin_date }}</span>
                                        <span>{{ dailyHour.daily_hours }} Hora(s)</span>
                                        <i class="fa-regular fa-trash-can clickable" @mouseenter="Gems.Tooltip($event.target, 'Remover quantidade de hora(s) contratada(s)', 'tooltip')"
                                         @click="RemoveWorkingHour(dailyHour)" v-if="isAdmin"></i>
                                    </div>
                                </div>
                            </div>

                            <div class="align-self-start" v-if="isAdmin">
                                <div class="div-working-hours">
                                    <input type="date" v-model="newWorkingHours.date" class="input-working-hour-date" required>
                                    <input type="number" min="1" max="24" step="1" v-model.number="newWorkingHours.hours" @input="normalizeWorkingHoursHours()" class="input-working-hour" required>
                                    <i class="fa-solid fa-plus clickable"  @mouseenter="Gems.Tooltip($event.target, 'Adicionar nova quantidade de hora(s) contratada(s)', 'tooltip')" @click="AddWorkingHour()"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="div-user-info-container">

                    <div id="div-left" class="div-left" v-show="!manageUserHours">
                        <div class="div-left-container">
                            <div class="div-row">
                                <div class="div-internal">
                                    <label>N° INTERNO</label>
                                    <div class="">
                                        <input type="text" v-model="internal" required
                                            :class="{ 'disabled': !isAdmin }">
                                    </div>
                                </div>
                                <div class="div-professional-name">
                                    <label>NOME PROFISSIONAL</label>
                                    <div class="">
                                        <input type="text" v-model="professionalName" required :class="{ 'disabled': !isAdmin }">
                                    </div>
                                </div>
                            </div>

                            <div class="div-row">
                                <div class="div-full-name">
                                    <label>NOME COMPLETO</label>
                                    <div class="">
                                        <input type="text" v-model="fullName" :class="{ 'disabled': !isAdmin }">
                                    </div>
                                </div>
                            </div>

                            <div class="div-row">
                                <div class="div-gender">
                                    <label>GÉNERO</label>
                                    <div>
                                        <select v-model="genderId" :class="{ 'disabled': !isAdmin }">
                                            <option value="null">--</option>
                                            <option :value="gender.id" v-for="(gender, index) in userData.gender"
                                                :key="index">
                                                {{
                                                    gender.designation }}</option>
                                        </select>
                                    </div>

                                </div>
                                <div class="div-category">
                                    <label>CATEGORIA</label>
                                    <div class="">
                                        <select v-model="categoryId" :class="{ 'disabled': !isAdmin }">
                                            <option value="null">--</option>
                                            <option :value="cat.id" v-for="(cat, index) in userData.categories"
                                                :key="index">{{
                                                    cat.designation }}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div class="div-row" v-if="props.userId">
                                <div class="div-teams">
                                    <label>EQUIPA(S)</label>
                                    <div class="div-team-content">
                                        <div v-for="(team, index) in userData.teams" :key="index"
                                            class="div-team-container">
                                            <div @mouseover="Gems.TooltipIfNeeded($event.target)">
                                                <div class="div-team line-clamp line-clamp-1">
                                                    {{ team.designation }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="div-team-container" v-if="!hasTeams">
                                            <div>
                                                <div class="div-no-team">--</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- <div class="div-hour-container" v-if="hasIntime">
                            <div class="div-hour-content">
                                <label>VALOR/HORA</label>
                                <div class="div-hour">
                                    <input type="text" v-model="hourValue" :class="{ 'disabled': !isAdmin }">
                                </div>
                            </div>

                            <div class="div-hour-content">
                                <label>CUSTO/HORA</label>
                                <div class="div-hour">
                                    <input type="text" v-model="costHour" :class="{ 'disabled': !isAdmin }">
                                </div>
                            </div>

                            <div class="div-hour-content">
                                <label>HORAS DIÁRIAS</label>
                                <div class="div-hour">
                                    <input type="text" v-model="dailyHours" :class="{ 'disabled': !isAdmin }">
                                </div>
                            </div>
                        </div> -->

                    </div>

                    <div id="div-right" class="div-right" v-show="!manageUserHours">

                        <div class="div-right-container">
                            <div class="div-row">
                                <div class="div-function">
                                    <label>FUNÇÃO</label>
                                    <div class="">
                                        <select v-model="jobId" :class="{ 'disabled': !isAdmin }">
                                            <option value="null">--</option>
                                            <option :value="job.id" v-for="(job, index) in userData.jobs" :key="index">
                                                {{ job.designation }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div class="div-row">
                                <div class="div-mail">
                                    <label>EMAIL</label>
                                    <div class="">
                                        <input type="email" v-model="email" required :class="{ 'disabled': !isAdmin }">
                                    </div>
                                </div>
                            </div>

                            <div class="div-row">
                                <div class="div-username">
                                    <label>USERNAME</label>
                                    <div class="">
                                        <input type="text" v-model="username" required
                                            :class="{ 'disabled': !isAdmin }">
                                    </div>
                                </div>
                            </div>

                            <div class="div-row" v-if="props.userId">
                                <div class="div-headships">
                                    <label>CHEFIA(S) DIRETA(S)</label>
                                    <div class="div-headships-content">
                                        <div v-for="(head, index) in userData.hierarchy" :key="index">
                                            <div @mouseover="Gems.TooltipIfNeeded($event.target)">
                                                <div class="div-headship-user line-clamp line-clamp-1">
                                                    {{ head.headship_name }}
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="!hasHeadship">
                                            <div>
                                                <div class="div-headship-user">--</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>

                    </div>
                    
                    <div id="div-left" class="div-left">
                        <div class="div-left-container">
                            <div class="div-update-user-info" v-if="hasIntime">
                                <div class="inputs-border">
                                    <button id="btn-edit-user" class="button" @click="manageUserHours = !manageUserHours">
                                        {{ `${store.getters.User.apps?.intime?.admin ? "GERIR" : "VER"} ${!manageUserHours ? "HORAS CONTRATADAS" : "INFO PESSOAL"}` }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div id="div-right" class="div-right" v-show="!manageUserHours">
                        <div class="div-update-user-info">
                            <div class="inputs-border" :class="{ 'hover-inputs-border': isAdmin }" v-if="isAdmin">
                                <button id="btn-edit-user" class="button" @click="UpdateUserInfo()">{{ props.userId ? "GRAVAR" : "CRIAR UTILIZADOR" }}</button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
select,
input {
    font-family: "Poppins", sans-serif;
    background-color: var(--default-input-background);
    border: none;
    padding-left: 5px;
}

label {
    margin-bottom: 3px;
}

.div-hour {
    margin-top: 3px;
}

.div-container {
    gap: 20px;
}

.div-user-content {
    display: flex;
    flex-direction: column;
}

.div-modal-content {
    padding: 0px 14px 18px 16px;
}

.div-close-modal {
    display: flex;
    justify-content: flex-end;
    padding-top: 10px;
    z-index: 11;
}

.div-user-image-container {
    margin-top: -5px;
    padding-bottom: 5px;
}

.div-user-image-container,
.div-user-image {
    display: flex;
    justify-content: center;
    border-radius: 50%;
}

.div-user-image-content,
.div-user-image img {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 140px;
    width: 140px;
    border-radius: 50%;
    object-fit: cover;
}

.div-user-image img {
    cursor: pointer;
}

.fa-times {
    font-size: 1.5rem;
}

.div-gender,
.div-internal {
    width: 30%;
}

.div-username input,
.div-mail input,
.div-function select,
.div-category select,
.div-gender select,
.div-full-name input,
.div-professional-name input,
.div-internal input,
.div-working-hours input {
    height: 35px;
    width: 100%;
    color: white;
    border-radius: 7px;
}

.div-category,
.div-professional-name {
    width: 70%;
}

.div-headships,
.div-username,
.div-teams,
.div-mail,
.div-function,
.div-full-name {
    width: 100%;
}

.div-team,
.div-headship-user {
    flex-direction: row !important;
}

.div-user-info-container {
    display: grid;
    grid-template-columns: 50% 50%;
    gap: inherit;
}

.div-row div,
.div-container,
.div-full-name,
.div-professional-name {
    display: flex;
    flex-direction: column;
}


.div-headship-user,
.div-no-team,
.div-team,
.div-date-working-hour {
    align-items: center;
    justify-content: center;
    border: 1px solid grey;
    background-color: black;
    border-radius: 7px;
    width: 100%;
    line-height: 2;
    height: 40px;
    align-content: center;
}

.div-row {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
    width: 95%;
}

.div-left-container,
.div-right-container,
.div-right,
.div-left {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.div-left {
    justify-content: space-between;
}

.div-headships-content {
    gap: 5px;
}

.div-headship-user {
    text-align: center;
}

.div-team-content {
    width: 100%;
}

.div-team-container {
    text-align: center;
}

.div-update-user-info {
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    /* margin-top: 25px; */
    margin-top: 20px;
    height: 100%;
    width: 100%;
}

.div-update-user-info div {
    width: 95%;
}

.disabled {
    opacity: 1;
}

.inputs-border:has(.disabled):hover {
    background: var(--input-gradient-border);
}

.div-hour-container {
    display: grid;
    grid-template-columns: 33.3% 33.3% 33.3%;
    width: 95%;
    gap: 1.6%;
}

.div-hour-content div {
    width: 90%;
}

.div-hour-content input {
    width: 100%;
}

.div-hour {
    display: flex;
}

.div-hour input {
    border-radius: 7px;
    height: 35px;
}

.div-team-content {
    display: flex;
    flex-direction: column;
    gap: 5px;
}

#icon-close-modal:hover {
    color: var(--default-hover-color);
}

.div-working-hours {
    display: flex;
    gap: 10px;
    flex-direction: row !important;
    align-items: center;
    justify-content: flex-end;
}

.div-date-working-hour {
    gap: 10px;
    display: flex;
    flex-direction: row !important;
    padding: 5px;
    width: 280px;
    justify-content: space-between;
}

.div-date-working-hour span:nth-child(1) {
    width: 150px;
}

.div-date-working-hour span:nth-child(2) {
    width: 100px;
}

.div-manage-user-hours {
    height: 291px;
    overflow-y: auto;
    width: 100%;
}

.div-add-working-hour {
    width: 99%;
    justify-content: space-between;
    padding-top: 3px;
}

.input-working-hour {
    width: 20% !important;
}

.input-working-hour-date {
    width: 50% !important;
}

.align-self-start {
    align-self: flex-start;
}

.div-daily-hours-content {
    gap: 5px;
}

@media screen and (max-width: 1280px) {

    .div-headship-user,
    .div-team {
        padding: 1px 10px !important;
        line-height: 3;
    }
}

@media screen and (min-width: 1300px) and (max-width: 1530px) {

    .div-headship-user,
    .div-team {
        padding: 3px 10px !important;
    }
}

@media screen and (max-width: 1750px) {

    .div-headship-user,
    .div-team {
        padding: 2px 10px;
    }
}
</style>
